module.exports = __webpack_public_path__ + "img/Standard-icon-selected.aba8c769.png";